module.exports = __webpack_public_path__ + "static/img/ddhzyk-img4.75c1eb8c.jpg";